import React from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { AnchorLogo } from './Icons';

export function AdsByAnchorLogo({
  id,
  small = false,
}: {
  id: string;
  small?: boolean;
}) {
  const t = useT();
  return (
    <>
      {t(
        'AdsByAnchorScreen.Header.HeaderContent.Title',
        'Ads by {anchorLogo}',
        'Ads by Anchor marketing page title. {anchorLogo} will replace by "Anchor" text logo with a registered mark icon next to it',
        {
          anchorLogo: <AnchorLogo small={small} aria-hidden={true} id={id} />,
        }
      )}
    </>
  );
}
